import { RouteObject } from "react-router-dom";
import CreateDealers from "pages/taylormade-warranty/dealers/create";
import ListDealers from "pages/taylormade-warranty/dealers/list";
import WarrantyReport from "pages/taylormade-warranty/report/warranty-report";
import EditWarrantyReport from "pages/taylormade-warranty/report/edit-warranty-report";

const TaylormadeWarrantyRouters: RouteObject[] = [
  {
    path: "/taylormade/warranty-report",
    element: <WarrantyReport />,
  },
  {
    path: "/taylormade/warranty-report/:id/edit",
    element: <EditWarrantyReport />,
  },
  {
    path: "/taylormade/dealers/list",
    element: <ListDealers />,
  },
  {
    path: "/taylormade/dealers/create",
    element: <CreateDealers />,
  },
  //   {
  //     path: "/taylormade/dealers/:id",
  //     element: <DealersDetail />,
  //   },
  //   {
  //     path: "/taylormade/dealers/:id/edit",
  //     element: <EditDealers />,
  //   },
];

export default TaylormadeWarrantyRouters;
